import React from 'react';
import If from 'components/if-statement';
import RisSearchResult from 'routes/surface/components/node-modal-form/components/ris-search-modal/components/ris-search-results';
import RisSearchForm from 'routes/surface/components/node-modal-form/components/ris-search-modal/components/ris-search-form';
import { withModal } from 'hoc';
import { RisTypeSearch } from 'graphql/types';
import { ModalContext } from 'hoc/with-modal';

export interface RisSearchNodeFormProps {
  data: any;
  modal: ModalContext;
}

function RisSearchNodeForm({ data, modal }: RisSearchNodeFormProps) {
  const [searchData, setSearchData] = React.useState({
    search: '',
    type: RisTypeSearch.FederalStandards,
  });

  function onSearchFormSubmit({ search, type }) {
    setSearchData({ search: search?.trim(), type });
  }

  function showSearchForm() {
    setSearchData((data) => ({ ...data, search: '' }));
  }

  function setFilter(filter) {
    setSearchData((previousData) => ({ ...previousData, ...filter }));
  }

  return (
    <If condition={searchData.type && searchData.search}>
      <If.Then>
        <RisSearchResult
          data={data}
          modal={modal}
          filter={searchData}
          setFilter={setFilter}
          showSearchForm={showSearchForm}
        />
      </If.Then>
      <If.Else>
        <RisSearchForm
          initialValues={searchData}
          onSubmit={onSearchFormSubmit}
          modal={modal}
        />
      </If.Else>
    </If>
  );
}

export default withModal(RisSearchNodeForm);
